export default __webpack_public_path__ + "static/media/96a46feb08733aed12bb9e379fb9b1ee1576593368961.c2d712d6.webp";